<template>
  <div class="h-screen w-screen flex bg">
    <div class="w-1/4 p-2">
      <div
        class="h-32 w-full bg-white mb-12"
        v-for="(item,i) of shadows"
        :key="i"
        @click="()=> boxShadow=item"
      >
        <div class="h-full w-full p-6 overflow-hidden">
          <div class="w-full h-full bg-teal-400 rounded" :style="{boxShadow:item.style}"></div>
        </div>
        <div class="bg-white pb-2 px-2 text-xs flex items-center justify-between cursor-default">
          <div>{{item.name}}</div>
          <div class="text-red-600" @click="item.remove()">delete</div>
        </div>
      </div>
    </div>
    <div class="w-2/4 bg-gray-200 p-24 overflow-hidden" style="height:90vh">
      <div class="w-full h-full bg-orange-400 rounded" :style="{boxShadow:boxShadow.style}"></div>
    </div>
    <div class="w-1/4 p-12 text-white">
      <div>Horizontal Length</div>
      <vue-slider v-model="boxShadow.horizontalLength" @change="onChange()"></vue-slider>
      <div>Vertical Length</div>
      <vue-slider v-model="boxShadow.verticalLength" @change="onChange()"></vue-slider>
      <div>Blur Radius</div>
      <vue-slider v-model="boxShadow.blurRadius" @change="onChange()"></vue-slider>
      <div>Spread Radius</div>
      <vue-slider v-model="boxShadow.spreadRadius" @change="onChange()"></vue-slider>
      <div>Opacity Radius</div>
      <vue-slider v-model="boxShadow.opacity" @change="onChange()"></vue-slider>

      <div class="flex justify-center items-end">
        <button
          class="bg-teal-600 text-white text-xs px-3 py-1 my-2 mr-2 flex items-center"
          @click="resetBoxShadow()"
        >
          <RefreshCwIcon size="12" />
          <div class="ml-2">Reset</div>
        </button>
      </div>
      <div class="flex items-end justify-evenly">
        <VInput type="text" label="Name" :value="boxShadow.name" v-model="boxShadow.name" />
        <VButton
          v-if="boxShadow.doc == null"
          :disabled="!boxShadow.name.trim()"
          label="Save"
          @click="save()"
        />
        <VButton v-else label="Update" @click="update()" />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { UUID, UiSelect, UiTabs } from "@/util";
import { mapState, mapGetters, mapActions } from "vuex";
import firebase, { firestore } from "firebase";
import { AppService, Gradient, GradientColor, BoxShadow } from "../../store";
import { Component } from "../../store/models/component.model";
import ColorPicker from "vue-color-picker-wheel";
import Vue from "vue";

export default {
  name: "BoxShadowCreator",
  components: {
    ColorPicker
  },
  data() {
    return {
      boxShadow: new BoxShadow()
    };
  },
  mounted() {
    BoxShadow.loadBoxShadowsToDom(list => {
      this.shadows = list;
    });
  },
  computed: {
    ...mapState(["shadows"])
  },
  methods: {
    resetBoxShadow() {
      this.boxShadow = new BoxShadow();
    },
    onChange() {},
    save() {
      this.boxShadow.create().then(() => {});
    },
    update() {
      this.boxShadow.update();
    }
  }
};
</script>

<style scoped>
</style>